module.exports = __webpack_public_path__ + "img/img_slide_11.1dda9df9.webp";